<template>
    <div class="scope-cent8">
        <div class="bg-video">
			<video data-v-0556c46b="" x5-video-player-type="h5" playsinline="" webkitplaysinline="true" muted="muted"
				autoplay="autoplay" loop="loop" src="@/assets/temimg8/video-bg_1.mp4" poster="" x5-playsinline=""
				webkit-playsinline="" controlslist="nodownload"
				style="width: 680px; object-fit: fill; opacity: 1; transform: none;">
            </video>
        </div>
        <div class="scope-left"></div>
        <div class="scope-right"></div>
        <div class="scope-dz"></div>
        <div class="center-scope">
            <div class="stext1">{{ defaultdata[0].value4 }}</div>
            <div class="stext2">{{ defaultdata[0].value3 }}</div>
        </div>
        <div class="scope-bottom-group">
            <div v-for="(item, i) in defaultdata" :key="i" :class="`scope-item scope-item-${i}`">
                <div class="vtext1">{{ item.value1 }}</div>
                <div class="vtext2">{{ item.value2 }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import * as methods from "@/components/scope/method.js";

export default {
    name: "template8.center",
    props: {
        vdata: {
            type: [Array, String],
            default: () => []
        },
        jsondata: {
            type: [Array, String],
            default: () => []
        },
        scopedata: {
            type: Object,
            default: () => { }
        }
    },
    data() {
        return {
            defaultdata: [
                { value1: '金质健康', value2: 'KeyOffice · Health', value3: '云擎商服体系', value4: 'Key office' },
                { value1: '金悦生活', value2: 'KeyOffice · Life' },
                { value1: '金彩人文', value2: 'KeyOffice · Art' },
                { value1: '金牌论坛', value2: 'Keyoffice · KOL' },
                { value1: '金益求精', value2: 'KeyOffice · quality' },
            ],
            valueMap: [
                { name: '底部标题', key: 'value1' },
                { name: '底部标题英文', key: 'value2' },
                { name: '中心标题', key: 'value3' },
                { name: '中心标题英文', key: 'value4' },
            ],
            exceldata: [],
            apiconfig: {},
            isApi: false,
            scope: {},
            autoTimePaused: false,
        }
    },
    methods: {
        ...methods
    },
    mounted() {
        if (this.vdata && this.vdata.length) {
            this.defaultdata = this.vdata;
        }
        if (this.jsondata && this.jsondata.length) {
            this.exceldata = this.jsondata;
        }
        this.setData()
    }
}
</script>

<style scoped lang="scss">
.scope-cent8 {
    width: 100%;
    height: 100%;
    position: relative;
    color: #fff;
    .scope-left {
        width: 291px;
        height: 641px;
        position: absolute;
        left: 0;
        top: calc(42% - 320px);
        background: url(@/assets/temimg8/zuo.png) no-repeat;
        background-size: 100% 100%;
        animation: lefttrans 3s linear infinite;
    }
    .scope-right {
        width: 291px;
        height: 641px;
        position: absolute;
        right: 0;
        top: calc(42% - 320px);
        background: url(@/assets/temimg8/you.png) no-repeat;
        background-size: 100% 100%;
        animation: righttrans 3s linear infinite;
    }
    @keyframes lefttrans {
        0% {
            transform: translateX(15px);
        }
        50% {
            transform: translateX(0);
        }
        100% {
            transform: translateX(15px);
        }
    }
    @keyframes righttrans {
        0% {
            transform: translateX(-15px);
        }
        50% {
            transform: translateX(0);
        }
        100% {
            transform: translateX(-15px);
        }
    }
    .bg-video {
        position: absolute;
        left: 50%;
        top: 40%;
        transform: translate(-50%, -50%);
        background: transparent;
        mix-blend-mode: lighten;
        video {
            width: 680px;
            height: 680px;
            background: transparent;
        }
    }
    .scope-dz {
        width: 1072px;
        height: 329px;
        background: url(@/assets/temimg8/dz.png) no-repeat;
        background-size: 100% 100%;
        position: absolute;
        bottom: 0;
        left: calc(50% - 536px);
        // animation: rotatedz 5s linear infinite;
    }
    @keyframes rotatedz {
        0% {
            transform: rotate(0, 0);
        }
        100% {
            transform: rotate(0, 360deg);
        }
    }
    .center-scope {
        text-align: center;
        position: absolute;
        left: 50%;
        top: 30%;
        transform: translateX(-50%);
        z-index: 1;
        .stext1 {
            font-family: Source Han Sans CN;
            font-weight: 400;
            font-size: 43px;
            color: #FFFFFF;
        }
        .stext2 {
            font-family: PangMenZhengDao;
            font-weight: 400;
            font-size: 60px;
            color: #FFFFFF;
            margin-top: 26px;
        }
    }
    .scope-bottom-group {
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        width: 100%;
        z-index: 2;
        position: absolute;
        bottom: 68px;
        text-align: center;
        .scope-item {
            width: 134px;
            height: 171px;
            background: url(@/assets/temimg8/scope-bg.png) no-repeat;
            background-size: 100% 100%;
        }
        .vtext1 {
            margin-top: 12px;
            font-family: PangMenZhengDao;
            font-weight: 400;
            font-size: 24px;
            color: #00E1FF;
        }
        .vtext2 {
            font-family: Source Han Sans CN;
            font-weight: 400;
            font-size: 14px;
            color: #D5EEFF;
        }
        .scope-item-0,
        .scope-item-4 {
            margin-bottom: 92px;
        }
        .scope-item-1,
        .scope-item-3 {
            margin-bottom: 30px;
        }
    }
}
</style>